import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` PGP signatures will be deprecated early 2023, in favour of ECDSA registry signatures that can be verified using the npm CLI. More information will soon be provided.`}</p>
    </Note>
    <p>{`To ensure the integrity of a package version you download from the npm public registry, you can manually verify the `}<a parentName="p" {...{
        "href": "about-pgp-signatures-for-packages-in-the-public-registry"
      }}>{`PGP signature`}</a>{` of the package.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` Since fully verifying signatures on Keybase requires rechecking proofs (which requires network activity) and is therefore expensive, we recommend only verifying signatures if it is necessary -- for example, when verifying a deploy artifact, or when initially storing a package in your cache.`}</p>
    </Note>
    <h2>{`Prerequisites`}</h2>
    <ol>
      <li parentName="ol">{`Install Keybase from `}<a parentName="li" {...{
          "href": "https://keybase.io/download"
        }}>{`https://keybase.io/download`}</a></li>
      <li parentName="ol">{`Create a Keybase account on `}<a parentName="li" {...{
          "href": "https://keybase.io"
        }}>{`https://keybase.io`}</a></li>
      <li parentName="ol">{`Follow "`}<a parentName="li" {...{
          "href": "https://keybase.io/npmregistry"
        }}>{`npmregistry`}</a>{`" on Keybase.`}</li>
      <li parentName="ol">{`Download a local copy of the npm public registry's `}<a parentName="li" {...{
          "href": "https://keybase.io/npmregistry/pgp_keys.asc"
        }}>{`public PGP key`}</a>{`.`}</li>
    </ol>
    <h2>{`Verifying npm signatures for the public registry`}</h2>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` The following steps use version 1.4.3 of the `}<inlineCode parentName="p">{`light-cycle`}</inlineCode>{` package as an example.`}</p>
    </Note>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, fetch the signature for the package version you want and save it in a file:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm view light-cycle@1.4.3 dist.npm-signature > sig-to-check
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Get the integrity field for that version (example below includes response):`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm view light-cycle@1.4.3 dist.integrity
`}</code></pre>
        <p parentName="li">{`Example response:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`sha512-sFcuivsDZ99fY0TbvuRC6CDXB8r/ylafjJAMnbSF0y4EMM1/1DtQo40G2WKz1rBbyiz4SLAc3Wa6yZyC4XSGOQ==
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Construct the string that ties the unique package name and version to the integrity string (example below includes response):`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`keybase pgp verify --signed-by npmregistry -d sig-to-check -m 'light-cycle@1.4.3:sha512-sFcuivsDZ99fY0TbvuRC6CDXB8r/ylafjJAMnbSF0y4EMM1/1DtQo40G2WKz1rBbyiz4SLAc3Wa6yZyC4XSGOQ=='
`}</code></pre>
        <p parentName="li">{`Example response:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`▶ INFO Identifying npmregistry
✔ public key fingerprint: 0963 1802 8A2B 58C8 4929 D8E1 3D4D 5B12 0276 566A
✔ admin of DNS zone npmjs.org: found TXT entry keybase-site-verification=Ls8jN55i6KesjiX91Ck79bUZ17eA-iohmw2jJFM16xc
✔ admin of DNS zone npmjs.com: found TXT entry keybase-site-verification=iK3pjpRBkv-CIJ4PHtWL4TTcFXMpPiwPynatKl3oWO4
✔ "npmjs" on twitter: https://twitter.com/npmjs/status/981288548845240320
Signature verified. Signed by npmregistry 3 years ago (2018-04-13 15:00:37 -0700 MST).
PGP Fingerprint: 096318028a2b58c84929d8e13d4d5b120276566a.
`}</code></pre>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      